import { render, staticRenderFns } from "./cabinAllowanceQuery.vue?vue&type=template&id=af777700&scoped=true&"
import script from "./cabinAllowanceQuery.vue?vue&type=script&lang=js&"
export * from "./cabinAllowanceQuery.vue?vue&type=script&lang=js&"
import style0 from "./cabinAllowanceQuery.vue?vue&type=style&index=0&id=af777700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af777700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af777700')) {
      api.createRecord('af777700', component.options)
    } else {
      api.reload('af777700', component.options)
    }
    module.hot.accept("./cabinAllowanceQuery.vue?vue&type=template&id=af777700&scoped=true&", function () {
      api.rerender('af777700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/cabinAllowanceQuery.vue"
export default component.exports